import React, { useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { FaCheck, FaStar } from "react-icons/fa";
import Product from "../../images/product.png";
import Product1 from "../../images/product1.png";
import ContactForm from "../contact-form/contact-form";
import "./product.scss";

const ProductSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const openForm = (productTitle) => {
    setSelectedProduct(productTitle);
    setIsFormOpen(true);
  };
  const closeForm = () => setIsFormOpen(false);

  const products = [
    {
      id: 1,
      image: Product,
      title: "3-дневный курс",
      description: "Мягкое очищение для начинающих",
      price: "660,000 сум",
      features: ["5 соков в день", "Детокс-инструкция", "Поддержка 24/7"],
      popular: false,
    },
    {
      id: 2,
      image: Product1,
      title: "5-дневный курс",
      description: "Глубокое очищение и перезагрузка",
      price: "880,000 сум",
      features: ["5 соков в день", "План питания", "Персональная консультация"],
      popular: true,
    },
  ];

  return (
    <motion.div
      className="product-big"
      id="programs"
      ref={ref}
      initial={{ opacity: 0 }}
      animate={isInView ? { opacity: 1 } : { opacity: 0 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1
        className="product-title"
        initial={{ opacity: 0, y: 50 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        Выберите свою программу
      </motion.h1>

      <div className="products">
        {products.map((product, index) => (
          <motion.div
            key={product.id}
            className={`product-card ${product.popular ? "popular" : ""}`}
            initial={{ opacity: 0, y: 100 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
            transition={{ duration: 0.8, delay: 0.4 + index * 0.2 }}
            whileHover={{
              y: -10,
              transition: { duration: 0.3 },
            }}
          >
            {product.popular && (
              <motion.span
                className="badge"
                initial={{ scale: 0, rotate: -180 }}
                animate={
                  isInView ? { scale: 1, rotate: 0 } : { scale: 0, rotate: -180 }
                }
                transition={{ duration: 0.6, delay: 0.8 + index * 0.2 }}
              >
                <FaStar /> Популярный
              </motion.span>
            )}

            <motion.div
              className="product-image"
              whileHover={{ scale: 1.1, rotate: 5 }}
              transition={{ duration: 0.3 }}
            >
              <img src={product.image} alt={product.title} />
            </motion.div>

            <h2>{product.title}</h2>
            <p className="product-desc">{product.description}</p>

            <motion.h3
              className="price"
              animate={{
                scale: [1, 1.05, 1],
                color: ["#fbbd33", "#f59e0b", "#fbbd33"],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              {product.price}
            </motion.h3>

            <ul className="features">
              {product.features.map((feature, featureIndex) => (
                <motion.li
                  key={featureIndex}
                  initial={{ opacity: 0, x: -20 }}
                  animate={
                    isInView
                      ? { opacity: 1, x: 0 }
                      : { opacity: 0, x: -20 }
                  }
                  transition={{
                    duration: 0.6,
                    delay: 0.6 + index * 0.2 + featureIndex * 0.1,
                  }}
                  whileHover={{ x: 5, scale: 1.02 }}
                >
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={isInView ? { scale: 1 } : { scale: 0 }}
                    transition={{
                      duration: 0.3,
                      delay: 0.8 + index * 0.2 + featureIndex * 0.1,
                    }}
                  >
                    <FaCheck className="check-icon" />
                  </motion.div>
                  {feature}
                </motion.li>
              ))}
            </ul>

            <motion.button
              className="buy-btn"
              onClick={() => openForm(product.title)} // ✅ Pass course name
              whileHover={{
                scale: 1.05,
                boxShadow: "0 8px 25px rgba(251, 189, 51, 0.4)",
              }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ duration: 0.6, delay: 0.8 + index * 0.2 }}
            >
              Заказать
            </motion.button>
          </motion.div>
        ))}
      </div>

      {/* ✅ Pass selectedProduct to ContactForm */}
      <ContactForm
        isOpen={isFormOpen}
        onClose={closeForm}
        selectedProduct={selectedProduct}
      />
    </motion.div>
  );
};

export default ProductSection;
